import React from 'react';

import { MarketShell } from '../../design-system/components/shells';
import { Card, PageHeader, Skeleton, SkeletonRow } from '../../design-system/components/desktop';
import { ConsoleStack, StatGrid } from '../../design-system/patterns/console';

import './dashboard.css';

/**
 * The role router's own screen, the one state `/dashboard` can be in before it
 * knows which dashboard it is.
 *
 * WHY THIS IS A SCREEN AND NOT A SPINNER
 * --------------------------------------
 * The old router rendered a bare `LoadingSpinner` on an otherwise empty page,
 * so the shell, the sidebar and the page title all arrived a beat after the
 * route did and the whole viewport moved. Everything except the numbers is
 * already known at this point: the shell, the heading and the shape of the KPI
 * band. So those render immediately and only the values are skeletons. That is
 * the same rule `StatValue` follows inside the seller dashboard.
 *
 * It is deliberately NOT the seller layout. A user whose role is still being
 * resolved may turn out to be a buyer, and promising four seller KPI tiles to
 * someone about to be shown a collection is a worse lie than a slower page.
 * The band is four neutral tiles wide because that is the widest either role
 * uses, so nothing reflows once the answer arrives.
 */
export function DashboardRoleLoadingView() {
  return (
    <MarketShell title="Dashboard" breadcrumbs={[{ label: 'Dashboard' }]} showSearch={false}>
      <ConsoleStack>
        <PageHeader title="Dashboard" sub="Loading your dashboard" />
        <StatGrid>
          {[0, 1, 2, 3].map((index) => (
            <div className="dsk-stat" key={index}>
              <Skeleton shape="text" width="55%" />
              <Skeleton shape="title" width="70%" />
            </div>
          ))}
        </StatGrid>
        <Card flush>
          {[0, 1, 2, 3, 4].map((index) => (
            <SkeletonRow key={index} thumb />
          ))}
        </Card>
      </ConsoleStack>
    </MarketShell>
  );
}

export default DashboardRoleLoadingView;
